import styled from "styled-components";

const Root = styled.div`
	overflow: hidden;
`;

export default Root;
